<script lang="ts">
    import { cx } from '$lib/utils/cx';
</script>

<div
    class={cx(
        'flex w-full',
        'border-solid border-0 border-b border-gray-350 last:border-0',
        'text-gray-800',
        'outline-none',
        'bg-white',
        'text-transparent',
    )}
>
    <div
        class="flex-1 hover:no-underline focus:no-underline flex py-[8px] px-[12px] gap-x-[8px] outline-none"
    >
        <div
            class="force-w-[40px] force-h-[40px] rounded-full object-cover bg-gray-300 animate-pulse"
        />

        <div class="flex flex-col gap-y-[4px]">
            <div class={'text-14/[20px]'}>
                <span class={'bg-gray-300 animate-pulse rounded-md'}
                    >Lorem ipsum dolor sit amet dolor sit amet</span
                >
            </div>
            <div class="text-11/[120%]">
                <span class={'bg-gray-300 animate-pulse rounded-md'}
                    >Lorem ipsum dolor sit amet</span
                >
            </div>
        </div>
    </div>
</div>
